import React, { useEffect, useState } from 'react';
import { Container, Grid, Box, Typography, Avatar } from '@mui/material';
import { withRouter } from 'react-router-dom';
import { FiShoppingBag, FiTag } from 'react-icons/fi';
import v2_actionCampanhasVf from '../../actions/v2/produtos/v2_actionCampanhasVf';
import CardProduct from '../../components/CardProduct';
import v2_actionBuscarProduto from '../../actions/v2/produtos/v2_actionBuscarProduto';
import v2_actionCoresProdutos from '../../actions/v2/produtos/v2_actionCoresProdutos';
import ModalProduto from '../../components/ModalProduto';
import { agruparPorGrade, transformarEmArray } from '../../utils/functions';
import v2_actionTamanhosProdutos from '../../actions/v2/produtos/v2_actionTamanhosProdutos';
import { getDataUsuario } from '../../services/auth';

function HomePage() {
  const [campanhas, setCampanhas] = useState([]);
  const [open, setOpen] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [verProduto, setVerProduto] = useState(null);
  const [outrasCoresProduto, setOutrasCoresProduto] = useState([]);
  const [isProdutoApto, setIsProdutoApto] = useState(null);
  const [outrosTamanhos, setOutrosTamanhos] = useState([]);
  const [isEstoque, setIsEstoque] = useState(false);
  const [corProduto, setCorProduto] = useState(null);
  const [filialProduto, setFilialProduto] = useState(null);
  const [tamanhoProduto, setTamanhoProduto] = useState(null);
  const [produtoAbaixoEstoque, setprodutoAbaixoEstoque] = useState(false);
  const [loadingVerificaPreco, setLoadingVerificaPreco] = useState(false);


  const handleEscolheuCor = async (cores, referencia, cor) => {
    setCorProduto(cor);
    setOutrosTamanhos([]);
    setTamanhoProduto(null);
    setFilialProduto(null);
    setLoadingModal(true);

    let querys = `?referencia=${referencia}&cor_produto=${cor}`;
    const res = await v2_actionBuscarProduto(querys);
    if (res.status === 200 && res.data.produto) {
        setVerProduto(res.data.produto);
    }

    const tamanhos = await v2_actionTamanhosProdutos(`?referencia=${referencia}&cor_produto=${cor}&loja=${getDataUsuario().filial}`);
    if (tamanhos.status === 200 && tamanhos.data.produtos.length > 0) {
      const agrupadosPorGrade = agruparPorGrade(tamanhos.data.produtos);
      const resultadoFinal = transformarEmArray(agrupadosPorGrade);
      setOutrosTamanhos(resultadoFinal);
      setIsEstoque(true);
    } else {
      setIsEstoque(false);
    }
    setLoadingModal(false);


  };

  const handleClickOpen = async (data) => {
    const produto = data;
    setOpen(true)
    setIsProdutoApto(null);
    setLoadingModal(true);

    let querys = `?referencia=${produto.use_referencia}&cor_produto=${produto.use_cod_cor_produto}`;
    const res = await v2_actionBuscarProduto(querys);
    if (res.status === 200 && res.data.produto) {

      setVerProduto(res.data.produto);

      const cores = await v2_actionCoresProdutos(`?referencia=${produto.use_referencia}`);
      if (cores.status === 200) {
        setOutrasCoresProduto(cores.data.cores);
        await handleEscolheuCor(cores.data.cores, produto.use_referencia, produto.use_cod_cor_produto);
      }
      setLoadingModal(false);
    }
  }

  useEffect(() => {
    async function getCampanhas() {
      try {
        let querys = `?loja=${getDataUsuario().filial}`;
        const response = await v2_actionCampanhasVf(querys);
        console.log('Campanhas:', response.data.campanhas);
        setCampanhas(response.data.campanhas || []);
      } catch (error) {
        console.error('Erro ao buscar campanhas:', error);
      }
    }
    getCampanhas();
  }, []);

  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      <ModalProduto
        open={open}
        handleClickClose={() => setOpen(false)}
        produto={verProduto}
        onLoadProduct={produto => {
          setVerProduto(produto)
        }}
      />

      <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3 }}>
        <Grid container spacing={3}>
          {campanhas.map((campanha) => (
            <Grid item xs={12} key={campanha._id}>
              <Box
                sx={{
                  p: { xs: 2.5, md: 3 },
                  borderRadius: 2.5,
                  border: '1px solid',
                  borderColor: 'grey.200',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                  bgcolor: '#fff',
                  mb: 2,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                  <Avatar
                    sx={{
                      width: 36,
                      height: 36,
                      bgcolor: '#e8eaf0',
                      color: '#1a1a2e',
                    }}
                  >
                    <FiShoppingBag size={18} />
                  </Avatar>
                  <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: '#1a1a2e' }}>
                    {campanha.name}
                  </Typography>
                </Box>

                {Object.entries(
                  campanha.products.reduce((acc, produto) => {
                    const marca = produto.use_desc_marca || 'Outros';
                    if (!acc[marca]) acc[marca] = [];
                    acc[marca].push(produto);
                    return acc;
                  }, {})
                ).map(([marca, produtos]) => (
                  <Box key={marca} sx={{ mb: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                      <Avatar
                        sx={{
                          width: 36,
                          height: 36,
                          bgcolor: '#e8eaf0',
                          color: '#1a1a2e',
                        }}
                      >
                        <FiTag size={18} />
                      </Avatar>
                      <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: '#1a1a2e' }}>
                        {marca}
                      </Typography>
                    </Box>
                    <Grid container spacing={3}>
                      {produtos.map((produto) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={produto._id}>
                          <CardProduct
                            product={produto}
                            verProdutoProps={() => handleClickOpen(produto)}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                ))}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default withRouter(HomePage);
